import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../lang";

const EASE = [0.16, 1, 0.3, 1];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="border-t border-edge/60 px-6 py-24 md:px-10 md:py-40" data-testid="services-section">
      <div className="mb-20 grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-signal"
          >
            {t.services.overline}
          </motion.p>
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="font-display text-3xl font-semibold leading-tight tracking-tight md:col-span-8 md:text-5xl"
        >
          {t.services.heading}
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 gap-px border border-edge/60 bg-edge/40 md:grid-cols-2">
        {t.services.items.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
            className="group relative bg-void p-10 transition-colors duration-300 hover:bg-surface md:p-14"
            data-testid={`service-card-${s.n.replace(".", "")}`}
          >
            <div className="mb-16 flex items-start justify-between md:mb-24">
              <span className="font-mono text-[11px] tracking-[0.2em] text-muted-foreground">{s.n}</span>
              <ArrowUpRight className="h-5 w-5 text-muted-foreground opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:text-signal group-hover:opacity-100" />
            </div>
            <h3 className="mb-4 font-display text-2xl font-semibold tracking-tight md:text-3xl">{s.t}</h3>
            <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">{s.b}</p>
            <span className="absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-signal transition-transform duration-500 ease-out group-hover:scale-x-100" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
